import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { StorageService} from '../storage-service.service';
import { DataShareService} from '../cart.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  cartProduct = [];
  cartLength;
  totalLength : number = 0;
  clickEventsubscription:Subscription;

  constructor(private storageService: StorageService, private cd: ChangeDetectorRef, private dataShareService: DataShareService) {
    this.clickEventsubscription = this.dataShareService.getClickEvent().subscribe(()=>{
      this.ngOnchanges();
      })
   }

  ngOnInit(): void {
    this.getCartProduct();
    this.calculateTotalLength();
    this.cd.detectChanges();
  }


  calculateTotalLength() {
   this.totalLength = this.cartProduct.length;
  }

  ngOnchanges(){
    this.getCartProduct();
    this.calculateTotalLength();
  }

  getCartProduct() {
    this.storageService.getItem('cartProduct').subscribe(res => {
      this.cartProduct = JSON.parse(res);
      console.log(this.cartProduct);
    })
  }

}
